import React, { useCallback } from 'react'
import { Alert, Snackbar } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { setAlertOpen } from '../../store/reducers/alert/alertReducer'

const SnackbarAlert: React.FC = () => {

    const dispatch = useAppDispatch()
    const { alertOpen, alertMessage, alertSeverity } = useAppSelector(state => state.alert)

    const handleClose = useCallback((event: React.SyntheticEvent | Event, reason?: string) => {
        if(reason === 'clickaway') return
        dispatch(setAlertOpen(false))
    }, [dispatch])

    return(

        <Snackbar 
            open = {alertOpen} 
            autoHideDuration = {6000} 
            anchorOrigin = {{vertical: 'top', horizontal: 'center'}}
            onClose = {handleClose} 
        >
            <Alert severity = {alertSeverity ?? 'info'} variant = "filled" onClose = {handleClose}>{alertMessage}</Alert>
        </Snackbar>

    )

}

export default SnackbarAlert